import {BaseMuWidget} from "../BaseMuWidget";
import {CommonCL} from "../generated/CommonCL";
import {UiModalContainer} from "../UiModalContainer";
import {MuWidget} from "mu-widget/lib/MuWidget";
import {TicketsCL} from "../generated/TicketsCL";

export class RelatedAccountSelector extends BaseMuWidget {

	protected cl = new TicketsCL();

	// @ts-ignore
	public onSelect: (value: (PromiseLike<number | null> | number | null)) => void;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex">
				<h4 class="flex-grow-1" mu="label">Vyberte komu delegovat úkol.</h4>
				<span mu-id="bCloseUnderlings" class="close">&times;</span>
			</div>
			<div mu-bind="underlings:@visible">
				<h5>Podřízení</h5>
				<ul mu-id="underlings" mu-bind="underlings:@foreach">
					<li mu-template="itemU" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
						<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
					</li>
				</ul>				
			</div>
			<h5>Nadřízení</h5>
			<ul mu-id="superiors" mu-bind="superiors:@foreach">
				<li mu-template="itemS" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
					<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
				</li>
			</ul>
			<h5>Spolupracovníci</h5>
			<ul mu-id="collaborators" mu-bind="collaborators:@foreach">
				<li mu-template="itemC" mu-widget="RelatedAccountSelectorItem" mu-bind="id::.accountId">
					<div mu-id="name" mu-bind="name" class="btn btn-link"></div>
				</li>
			</ul>
		`);
	}

	public static open(label: string): Promise<number|null>
	{
		const widget = UiModalContainer.open("RelatedAccountSelector", label) as RelatedAccountSelector;
		return widget.newSelectPromise();
	}

	private newSelectPromise(): Promise<number|null> {
		return  new Promise<number|null>(resolve => this.onSelect = resolve);
	}

	muRemoveSelf() {
		this.onSelect(null);
		super.muRemoveSelf();
	}

	async afterIndex() {
		this.muBindData(await this.cl.getOrgRelatedAccounts(null));
	}

	selectAccount(accountId: number) {
		this.onSelect(accountId);
		this.muRemoveSelf();
	}
}

export class RelatedAccountSelectorItem extends MuWidget
{
	// @ts-ignore
	public accountId: number;
	name_click() {
		(this.muParent as unknown as RelatedAccountSelector).selectAccount(this.accountId);
	}
}